import React from "react";
import SectionHeader from "../SectionHeader/SectionHeader";
import HudFrame from "../HudFrame/HudFrame";
import useReveal from "../../useReveal";

const facts = [
  { k: "BASE", v: "Espoo, FI" },
  { k: "ROLE", v: "AI Solutions Architect" },
  { k: "INDUSTRY", v: "Insurance · 15+ years" },
  { k: "FOCUS", v: "Agentic AI" },
];

export default function About() {
  const ref = useReveal();

  return (
    <section
      id="about"
      ref={ref}
      style={{
        maxWidth: "var(--maxw)",
        margin: "0 auto",
        padding: "clamp(80px, 14vh, 160px) clamp(20px, 5vw, 48px)",
      }}
    >
      <SectionHeader index="01" kicker="crew dossier" title="About" />

      <div
        className="about-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "minmax(0, 1.4fr) minmax(0, 1fr)",
          gap: "clamp(32px, 6vw, 72px)",
          alignItems: "start",
        }}
      >
        {/* Left: prose */}
        <div>
          <p
            className="reveal"
            data-stagger="80"
            style={{
              fontFamily: "var(--display)",
              fontWeight: 500,
              fontSize: "clamp(1.4rem, 2.8vw, 2.1rem)",
              lineHeight: 1.35,
              marginBottom: "32px",
            }}
          >
            I turn AI from a promising idea into{" "}
            <em style={{ color: "var(--cyan)", fontStyle: "normal" }} className="glow-text">
              practical solutions
            </em>
            {" "}for the insurance business.
          </p>

          <p
            className="reveal"
            data-stagger="80"
            style={{
              fontSize: "1.04rem",
              lineHeight: 1.85,
              color: "var(--text-soft)",
              marginBottom: "22px",
              maxWidth: "60ch",
            }}
          >
            I am an AI Solutions Architect at Fennia, responsible for practical
            AI implementations and agentic coding. My daily work focuses on
            building AI agents and agentic workflows with Salesforce
            Agentforce, AWS Bedrock and Azure AI Foundry.
          </p>
          <p
            className="reveal"
            data-stagger="80"
            style={{
              fontSize: "1.04rem",
              lineHeight: 1.85,
              color: "var(--text-soft)",
              maxWidth: "60ch",
            }}
          >
            Before moving into AI, I was Dev Lead for the renewal of Oma Fennia,
            Fennia's digital service for personal customers. I combine that
            delivery experience with more than 15 years in insurance across
            sales, P&amp;C underwriting and digital services — from the first use
            case to a service people can actually use.
          </p>

          {/* Fact readout grid */}
          <div
            className="reveal"
            data-stagger="80"
            style={{
              marginTop: "44px",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
              gap: "12px",
            }}
          >
            {facts.map((f) => (
              <HudFrame key={f.k} style={{ padding: "16px 18px" }}>
                <div
                  style={{
                    fontFamily: "var(--mono)",
                    fontSize: "0.66rem",
                    letterSpacing: "0.14em",
                    color: "var(--cyan)",
                    marginBottom: "8px",
                  }}
                >
                  {f.k}
                </div>
                <div
                  style={{
                    fontFamily: "var(--display)",
                    fontSize: "1.15rem",
                    fontWeight: 600,
                    color: "var(--text)",
                  }}
                >
                  {f.v}
                </div>
              </HudFrame>
            ))}
          </div>
        </div>

        {/* Right: portrait in HUD frame */}
        <HudFrame
          className="reveal"
          data-stagger="120"
          style={{ padding: "10px", overflow: "hidden" }}
        >
          <div style={{ position: "relative", overflow: "hidden" }}>
            <img
              src="https://portfolio-images-juhani.s3.eu-north-1.amazonaws.com/juhani_rajalahti.jpg"
              alt="Juhani Rajalahti"
              style={{
                width: "100%",
                display: "block",
                filter: "grayscale(0.35) contrast(1.08) brightness(0.95)",
              }}
            />
            {/* cyan tint + scan sweep */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(180deg, rgba(52,224,255,0.10), transparent 40%, rgba(255,77,157,0.08))",
                mixBlendMode: "screen",
                pointerEvents: "none",
              }}
            />
            <div
              style={{
                position: "absolute",
                top: 0,
                bottom: 0,
                width: "30%",
                background:
                  "linear-gradient(90deg, transparent, rgba(52,224,255,0.18), transparent)",
                animation: "sweep 5s linear infinite",
                pointerEvents: "none",
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontFamily: "var(--mono)",
              fontSize: "0.66rem",
              letterSpacing: "0.12em",
              color: "var(--text-faint)",
              padding: "10px 4px 2px",
            }}
          >
            <span style={{ color: "var(--cyan)" }}>● REC</span>
            <span>SUBJECT: J.RAJALAHTI</span>
            <span>ID/001</span>
          </div>
        </HudFrame>
      </div>

      <style>{`
        @media (max-width: 860px) {
          .about-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
